import React, {
  useState,
  useCallback,
  useMemo,
  useEffect,
} from 'react';
import useWizardStore from '@zs/useWizardStore';
import cache from '@/cache';


export function useImageCache(
  eye: 'OD' | 'OS',
) {
  const cacheLoaded = useWizardStore(state => state.cacheLoaded);
  
  const cacheMemo = useMemo(() => {
    if (!cacheLoaded || cache.imageCount < 1 || !cache.images[eye])
      return undefined;
    return cache.images[eye];
  }, [eye, cacheLoaded]);

  return cacheMemo;
}
